export default "__VITE_ASSET__CLEh8DKO__"